import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { createContext } from "react";
import { Theme } from "@fluentui/react-components";
import { app, HostClientType } from "@microsoft/teams-js";

export const TeamsFxContext = createContext<{
  theme: Theme | undefined;
  themeString: string;
  context: app.Context | undefined;
  msalInstance: IPublicClientApplication | undefined;
  clientType: HostClientType | undefined;
  userInfo: AccountInfo | undefined;
}>({
  theme: undefined,
  themeString: "",
  context: undefined,
  msalInstance: undefined,
  clientType: undefined,
  userInfo: undefined,
});
